"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "travedona-monate": {
    "e7931a69": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "skipSearch": false
    }],
    "c-piedimonte": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "babe60c8": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-carolina": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f223be26": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-lanche": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "24928f99": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-tomasina": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "12ca5e7a": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-zavatte": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "79d5f83c": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "skipSearch": false
    }],
    "chiosetto": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a7a08a79": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "skipSearch": false
    }],
    "darsena": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "95746dad": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "skipSearch": false
    }],
    "fornace": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "310d3bbf": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "skipSearch": false
    }],
    "giardinetto": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e9ff9c7e": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "skipSearch": false
    }],
    "molini": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "beaaad46": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "skipSearch": false
    }],
    "moncucco": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d8a84208": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "skipSearch": false
    }],
    "montebello": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "96093e4e": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "skipSearch": false
    }],
    "piane": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "43eea9f5": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "skipSearch": false
    }],
    "ronco": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "552c682b": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "skipSearch": false
    }],
    "villa-rucellai": [{
      "hkey": "90687eb8",
      "slug": "travedona-monate",
      "name": "Travedona-Monate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;